import React, { Component, Fragment } from "react";
import "moment/locale/fr";

import List from "../../../components/list/List";
import Pagination from "components/pagination/Pagination";
import networkListColumn from "./NetworksList.utils";

class NetworksList extends Component {
  componentDidMount() {
    this.props.init("networks");
  }

  render() {
    const { networksList, page, pages, pageSize, nbItems, getNext } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des networks</h2>
        </div>
        <div class="p-content-page-center-content">
          <List columns={networkListColumn} data={networksList} defaultText="Aucun network trouvé." />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default NetworksList;



// WEBPACK FOOTER //
// src/containers/admin/network/NetworksList.js